import { IConfigurationContentData } from 'src/types/configuration';

import { decodeCfgFile } from './decode-cfg';
import { decodeZipFile } from './decode-zip';
import { IDecodedCfgFile } from './types';

export const loadImportedConfigFiles = async (
  files: File[],
): Promise<{
  decodedFiles: IDecodedCfgFile<IConfigurationContentData>[];
  failedFiles: number;
  warnings: string[];
}> => {
  const decodedResults = await Promise.allSettled(
    files.map(async (file) => {
      if (file.name.toLowerCase().endsWith('.zip')) {
        return decodeZipFile(file);
      }
      return [await decodeCfgFile(file)];
    }),
  );

  const decodedFiles = decodedResults.flatMap((result) =>
    result.status === 'fulfilled' ? result.value : [],
  );
  const failedFiles = decodedResults.filter(
    (result) => result.status === 'rejected',
  ).length;
  const warnings = decodedResults
    .filter(
      (result): result is PromiseRejectedResult => result.status === 'rejected',
    )
    .map((result) =>
      result.reason instanceof Error
        ? result.reason.message
        : 'Unknown import error',
    );

  return {
    decodedFiles,
    failedFiles,
    warnings,
  };
};
